import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import Api from './Api';
import LocalApi from './LocalApi';
import Session from './Session';
import { actualLevel, rulesForLevel } from './levels'

// Parse the URL to extract game ID and determine if it's remote
const pathSegments = window.location.pathname.split('/').filter(segment => segment !== '');
const runLocally = pathSegments[0] !== 'remote';
const levelOrGameId = runLocally ? pathSegments[0] : pathSegments[1]
const gameId = parseInt(levelOrGameId);

// Look for the auto start flag
const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
const autoStart = urlParams.get('start') === 'auto';

// Lookup that difficult in our rules
const level = actualLevel(levelOrGameId);
const rules = rulesForLevel(level);

// Create a new session
const session = new Session(gameId, 'human', level, rules);
const api = runLocally ? new LocalApi(session) : new Api(session);

// When a new game is created, we'll be notified so we can change our URL
// This way, if they then refresh the page – they don't have to start over
// Also they can share the link from their browser to invite another player to watch the game
api.onNewGame = (newGameId) => {
    const newPath = runLocally ? `/${newGameId}` : `/remote/${newGameId}`;
    window.history.replaceState(null, 'Retro Rabbit', newPath);
}

// Setup React
ReactDOM.render(<App api={api} autoStart={autoStart}/>, document.getElementById('root'));